import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {employeeEvaluationActions} from "./employeeEvaluationSlice";
import {employeeEvaluationApi} from "~/api";

function* fetchEvaluationList(action) {
	try {
		const response = yield call(employeeEvaluationApi.gets, action.payload);
		yield put(employeeEvaluationActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch evaluation list', error);
		yield put(employeeEvaluationActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(employeeEvaluationActions.setFilter(action.payload));
}

export default function* employeeEvaluationSaga() {
	yield takeLatest(employeeEvaluationActions.fetchData.type, fetchEvaluationList);
	yield debounce(500, employeeEvaluationActions.setFilterWithDebounce.type, handleSearchDebounce)
}
